module.exports = __webpack_public_path__ + "static/onlinecollaboration-812540580dd252a93c8ecc2fa724b561.svg";